<mat-form-field class="mat-block" [ngClass]="{'l-updated-field': isOverriden}">
  <mat-select
    id="ddTimezone"
    [compareWith]="compareTimezones"
    [formControl]="ctrl"
    [placeholder]="placeholder"
    [required]="ctrl.hasError('required')"
  >
    <mat-option *ngFor="let timezone of timezoneList" [value]="timezone">
      {{ ' (' + timezone.abbreviation + timezone.offset + ') ' + timezone.name }}
    </mat-option>
  </mat-select>
  <mat-error
    id="errTimezone"
    class="error-message"
    *ngIf="ctrl.hasError('required') &&
     (ctrl.dirty ||ctrl.touched)"
  >
    {{ "common.timezone_required" | translate }}
  </mat-error>
</mat-form-field>
